import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { EmploymentActions } from './employment.actions';
import { IEmploymentState } from './employment.state';

export const initialEmploymentState: IEmploymentState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const employmentReducerFn = createReducer(
  initialEmploymentState,
  on(EmploymentActions.reset, (state: IEmploymentState, action) => {
    return new StateBuilder<IEmploymentState>(initialEmploymentState).build();
  }),
  on(EmploymentActions.updateModel, (state: IEmploymentState, action) => {
    return new StateBuilder<IEmploymentState>(state, action).build();
  }),
  on(EmploymentActions.load, (state: IEmploymentState, action) => {
    return new StateBuilder<IEmploymentState>(state).toLoading().build();
  }),
  on(EmploymentActions.loadSuccess, (state: IEmploymentState, action) => {
    return new StateBuilder<IEmploymentState>(state, action).toLoaded().build();
  }),
  on(EmploymentActions.submit, (state: IEmploymentState, action) => {
    return new StateBuilder<IEmploymentState>(state).toLoading().build();
  }),
  on(EmploymentActions.submitSuccess, (state: IEmploymentState, action) => {
    return new StateBuilder<IEmploymentState>(state, action).toLoaded().build();
  })
);

export function employmentReducer(state: IEmploymentState | undefined, action: Action) {
  return employmentReducerFn(state, action);
}
